<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  visit: { type: Object, default: () => ({}) },
  reason: { type: String, default: '' },
  isLoading: { type: Boolean, default: false },
  isDone: { type: Boolean, default: false },
  errorMessage: { type: String, default: '' },
});

const emit = defineEmits(['notify', 'similar', 'close']);

const imovel = computed(() => props.visit?.imovel || {});
const title = computed(() => imovel.value?.titulo || 'Imóvel da visita');
const address = computed(() =>
  [imovel.value?.endereco, imovel.value?.bairro, imovel.value?.cidade]
    .filter(Boolean)
    .join(', ')
);
const media = computed(() => {
  const list = imovel.value?.midias || imovel.value?.media || [];
  const first = Array.isArray(list) ? list[0] : null;
  if (typeof first === 'string') return first;
  return first?.url || first?.src || first?.image_url || '';
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div class="grid gap-5">
    <div
      class="grid place-items-center rounded-lais border border-orange-200 bg-orange-50 px-4 py-5 text-center"
    >
      <span
        class="i-lucide-calendar-x-2 size-9 text-orange-700"
        aria-hidden="true"
      />
      <h3 class="mt-3 text-[17px] font-semibold text-lais-text">
        Esta visita está indisponível no momento
      </h3>
      <p class="mt-1 text-[13px] leading-relaxed text-lais-text-body">
        {{ reason || 'Não há horário disponível para esta visita agora.' }}
      </p>
    </div>

    <div
      class="flex gap-3 rounded-lais-sm border border-lais-border bg-white px-3 py-3"
    >
      <div
        class="grid size-16 shrink-0 place-items-center overflow-hidden rounded-lais-sm bg-lais-bg-soft"
      >
        <img
          v-if="media"
          :src="media"
          :alt="title"
          class="size-full object-cover"
        />
        <span
          v-else
          class="i-lucide-building-2 size-6 text-lais-text-empty"
          aria-hidden="true"
        />
      </div>
      <div class="min-w-0">
        <p class="truncate text-[14px] font-semibold text-lais-text">
          {{ title }}
        </p>
        <p class="mt-1 line-clamp-2 text-[12px] text-lais-text-muted">
          {{ address || 'Endereço não informado' }}
        </p>
        <p class="mt-2 text-[12px] font-semibold text-lais-primary">
          A visita atual será preservada.
        </p>
      </div>
    </div>

    <div
      v-if="isDone"
      class="rounded-lais-sm border border-emerald-200 bg-emerald-50 px-4 py-3 text-[13px] text-emerald-800"
    >
      Avisaremos quando houver horário disponível para este imóvel.
    </div>
    <div
      v-else-if="errorMessage"
      class="rounded-lais-sm border border-rose-200 bg-rose-50 px-4 py-3 text-[13px] text-rose-700"
    >
      {{ errorMessage }}
    </div>

    <div class="grid gap-2">
      <LaisPrimaryButton
        icon="i-lucide-bell"
        :is-loading="isLoading"
        :disabled="isDone"
        @click="emit('notify')"
      >
        {{ isDone ? 'Aviso registrado' : 'Avisar quando disponível' }}
      </LaisPrimaryButton>
      <LaisPrimaryButton
        variant="ghost"
        icon="i-lucide-building-2"
        @click="emit('similar')"
      >
        Ver similares
      </LaisPrimaryButton>
      <LaisPrimaryButton variant="link" @click="emit('close')">
        Manter visita atual
      </LaisPrimaryButton>
    </div>
  </div>
</template>
